<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="clearBranchData" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.branch_id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch_name_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a @click="showBranch(item.branch_id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import CircleButton from "../../../components/Button/CircleButton";
import InputTextField from "../../../components/Input/InputTextField";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "MainBranch",
  components: {Paginate, InputSearch, InputTextField, CircleButton, IconPencil },
  created() {
    this.getBranchTable(1);
  },
  data() {
    return {
      title: "Main Branch",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Update date" },
        { id: 4, text: "Order" },
        { id: 5, text: "Edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  methods: {
    goToBranchEdit() {
      this.$router.push("/branch/edit");
    },
    getBranchTable(page) {
      this.$store.dispatch("Branch/getBranch", page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    showBranch(id) {
      this.$store.dispatch("Branch/showBranch", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Branch/setFormBranch", res.result).then(() => {
            this.goToBranchEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    clearBranchData() {
      this.$store.dispatch("Branch/clearFormData").then(() => {
        this.goToBranchEdit();
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("Branch/getBranch", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
/*.branch-data {*/
/*  background-color: transparent;*/
/*  margin: 20px;*/
/*}*/
</style>
<style>
.theme--light.v-system-bar {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
